// extracted by mini-css-extract-plugin
export var adjacentSlide = "_pv-9";
export var arrowButtonContainer = "_pv-5";
export var arrowButtonIcon = "_pv-6";
export var carouselArrowButton = "_pv-2";
export var carouselElementContainer = "_pv-1";
export var currentSlide = "_pv-8";
export var left = "_pv-3";
export var otherSlide = "_pv-a";
export var productCarouselContainer = "_pv-0";
export var right = "_pv-4";
export var sliderOverflow = "_pv-7";